export default function preLogout () {
  sessionStorage && sessionStorage.clear()
}
